export default class CampaignPlanningDto {
    constructor(obj) {
        this.id = obj.id // Long,
        this.planningId = obj.planningId // Long,
        this.stationsPlan = obj.stationsPlan // Seq[Long],
        this.parametersToAddPlan = obj.parametersToAddPlan ?? [] // Seq[Long],
        this.parametersToDeletePlan = obj.parametersToDeletePlan ?? [] // Seq[Long],
        this.selectionsToAddPlan = obj.selectionsToAddPlan ?? [] // Seq[String],
        this.selectionsToDeletePlan = obj.selectionsToDeletePlan ?? [] // Seq[String],
    }
}